import { Button } from '@malesia/react-components/dist/src/components/Button';
import { PageTitle } from '@malesia/react-components/dist/src/components/Page/Title';
import { SFC } from '@malesia/react-components/dist/src/types/react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { allAdminRoutePaths } from '../../../containers/Routes/allAdminRoutePaths';
import { customerListPermissions } from '../../../permissions/adminPages/user/customerList';
import { useUserPermissions } from '../../../permissions/useUserPermissions';

export const CustomerListHeaderWithStore: SFC = () => {
    const userPermissions = useUserPermissions();

    return (
        <PageTitle
            text={
                <FormattedMessage
                    id='front-app/CustomerListPage:Title'
                    defaultMessage='Customers'
                />
            }
            rightSlot={
                <Link to={allAdminRoutePaths.userCustomerNew}>
                    <Button
                        icon='plus'
                        text={
                            <FormattedMessage
                                id='front-app/Agent/List:AddNewCustomer'
                                defaultMessage='Add new customer'
                            />
                        }
                    />
                </Link>
            }
            rightSlotHidden={!userPermissions.has(customerListPermissions.newLink)}
        />
    );
};
